<template>
  <div class="home">
    <el-scrollbar style="height: 100%">
      <div class="tabledata">
        <el-input
          v-model="keyword"
          placeholder="请输入奖励活动关键词"
          @input="searchKeyword"
        ></el-input>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,40,50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-table
          :data="tableData"
          style="width: 100%"
          max-height="700"
          border
          v-loading="loading"
        >
          <el-table-column
            prop="activityName"
            label="活动名称"
          >
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="开始时间"
          >
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="结束时间"
          >
          </el-table-column>

          <el-table-column
            prop="orderSumRes.estimateValidNum"
            label="预估有效订单数"
            v-if="!channelFlag"
          >
          </el-table-column>

          <el-table-column
            prop="orderSumRes.estimateCosPrice"
            label="预估计佣金额(GMV)"
            v-if="!channelFlag"
          >
          </el-table-column>

          <el-table-column
            prop="orderSumRes.estimateBonus"
            label="预估奖励金额"
            v-if="!channelFlag"
          >
          </el-table-column>

          <el-table-column
            prop="orderSumRes.actualValidNum"
            label="实际有效订单数"
            v-if="!channelFlag"
          >
          </el-table-column>

          <el-table-column
            prop="orderSumRes.actualCosPrice"
            label="实际计佣金额(GMV)"
            v-if="!channelFlag"
          >
          </el-table-column>

          <!-- <el-table-column
            prop="orderSumRes.actualBonus"
            label="奖励订单金额"
            v-if="!channelFlag"
          >
          </el-table-column> -->

          <!-- <el-table-column
            prop="orderSumRes.ygUv"
            label="预估结算UV"
            v-if="!channelFlag"
          >
          </el-table-column> -->

          <el-table-column
            prop="orderSumRes.uv"
            label="结算UV"
            v-if="!channelFlag"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="380"
          >
            <template slot-scope="scope">
              <el-button
                class="handel"
                @click="getActivityDetail(scope.row)"
                :loading="scope.row.fetchLoading"
              >获取详细数据</el-button>
              <el-button
                class="handel"
                @click="getActivityStat(scope.row)"
              >查看每日数据</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import { getActivityDetail } from "@/api/lgactivity";
import { getLgActivity } from "@/api/jdBonusActivity";
import store from "@/store";
import router from "@/router";
export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 50,
      total: 0,
      loading: false,
      keyword: "",
      channelFlag: ""
    };
  },
  mounted() {
    this.channelFlag = store.state.user.userInfo.userType >= 10 ? true : false;
    this.search();
  },
  methods: {
    async getActivityDetail(row) {
      this.loading = true;
      await getActivityDetail({
        activityId: row.activityId
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          if (res.data.code == 200) {
            this.$set(row, "orderSumRes", res.data.data);
          } else {
            this.$message({
              message: res.data.message,
              type: "warning"
            });
          }
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    searchKeyword(v) {
      this.keyword = v;
      this.search();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.search();
      }
    },
    nextPage() {
      this.currentPage++;
      this.search();
    },
    async search(val) {
      this.loading = true;
      await getLgActivity({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.keyword
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search(); // 重新搜索以更新分页数据
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search(); // 重新搜索以更新分页数据
    },
    getActivityStat(val) {
      let routeData = router.resolve({
        name: `灵感每日数据`,
        query: {
          activityId: val.activityId,
          startTime: val.startTime.slice(0, 10),
          endTime: val.endTime.slice(0, 10),
          activityName: val.activityName
        }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>

